export const SET_TOKEN = "SET_TOKEN";
export const LOGOUT = "LOGOUT";
export const SET_PROFILE = "SET_PROFILE";
export const SET_PROVIDER = "SET_PROVIDER";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const STORE_SIGNUP_INFO = "STORE_SIGNUP_INFO";
export const STORE_SIGNUP_STATUS = "STORE_SIGNUP_STATUS";
export const SHOW_LOADER = "SHOW_LOADER";
export const HIDE_LOADER = "HIDE_LOADER";
export const SET_SIGNUP_FLOW = "SET_SIGNUP_FLOW";
export const RESET_SIGNUP_FLOW = "RESET_SIGNUP_FLOW";


export const USER_ACTIONS = {
  USER_PROFILE: {
    _START: "USER_PROFILE_START",
    _SUCCESS: "USER_PROFILE_SUCCESS",
    _FAILURE: "USER_PROFILE_FAILURE"
  },
  PLAYER_LOADED: "PLAYER_LOADED"
};

export const HOME_PAGE_ACTIONS = {
  HOME_PAGE_STRUCTURE: {
    _START: "HOME_PAGE_STRUCTURE_START",
    _SUCCESS: "HOME_PAGE_STRUCTURE_SUCCESS",
    _FAILURE: "HOME_PAGE_STRUCTURE_FAILURE"
  },
  EPG_DATA: {
    _START: "HOME_PAGE_EPG_DATA_START",
    _SUCCESS: "HOME_PAGE_EPG_DATA_SUCCESS",
    _FAILURE: "HOME_PAGE_EPG_DATA_FAILURE"
  },
  LIVE_STREAM: {
    _START: "HOME_PAGE_LIVE_STREAM_START",
    _SUCCESS: "HOME_PAGE_LIVE_STREAM_SUCCESS",
    _FAILURE: "HOME_PAGE_LIVE_STREAM_FAILURE"
  },
  AUTO_RAIL: {
    _START: "HOME_PAGE_AUTO_RAIL_START",
    _SUCCESS: "HOME_PAGE_AUTO_RAIL_SUCCESS",
    _FAILURE: "HOME_PAGE_AUTO_RAIL_FAILURE"
  }
};

export const DETAIL_PAGE_ACTIONS = {
  SET_PLAYING_VIDEO: "DETAIL_PAGE_SET_PLAYING_VIDEO",
  RESET: "DETAIL_PAGE_RESET",
  HOME_PAGE_SECTION: {
    _START: "DETAIL_PAGE_SECTION_START",
    _SUCCESS: "DETAIL_PAGE_SECTION_SUCCESS",
    _FAILURE: "DETAIL_PAGE_SECTION_FAILURE"
  },
  RAIL: {
    _START: "DETAIL_PAGE_RAIL_START",
    _SUCCESS: "DETAIL_PAGE_RAIL_SUCCESS",
    _FAILURE: "DETAIL_PAGE_RAIL_FAILURE"
  },
  RELATED_TOPIC_RAIL: {
    _START: "DETAIL_PAGE_RELATED_TOPIC_RAIL_START",
    _SUCCESS: "DETAIL_PAGE_RELATED_TOPIC_RAIL_SUCCESS",
    _FAILURE: "DETAIL_PAGE_RELATED_TOPIC_RAIL_FAILURE"
  }
};

export const TIER_ACTIONS = {
  _RESET: "RESET_TIER_DATA",
  SUB_MENU: {
    _START: "SUB_MENU_START",
    _SUCCESS: "SUB_MENU_SUCCESS",
    _FAILURE: "SUB_MENU_FAILURE"
  },
  SUB_MENU_VIDEO: {
    _START: "SUB_MENU_VIDEO_START",
    _SUCCESS: "SUB_MENU_VIDEO_SUCCESS",
    _FAILURE: "SUB_MENU_VIDEO_FAILURE"
  },
  SUB_MENU_SPONSORED_BY_VIDEO: {
    _START: "SUB_MENU_SPONSORED_BY_VIDEO_START",
    _SUCCESS: "SUB_MENU_SPONSORED_BY_VIDEO_SUCCESS",
    _FAILURE: "SUB_MENU_SPONSORED_BY_VIDEO_FAILURE"
  }
};

export const SEE_ALL_ACTIONS = {
  SET_MANUAL_SEE_ALL: "SET_MANUAL_SEE_ALL",
  SEE_ALL_VIDEO: {
    _START: "SEE_ALL_ACTIONS_SEE_ALL_VIDEO_START",
    _SUCCESS: "SEE_ALL_ACTIONS_SEE_ALL_VIDEO_SUCCESS",
    _FAILURE: "SEE_ALL_ACTIONS_SEE_ALL_VIDEO_FAILURE"
  },
  HOME_PAGE_SECTION: {
    _START: "SEE_ALL_ACTIONS_HOME_PAGE_SECTION_START",
    _SUCCESS: "SEE_ALL_ACTIONS_HOME_PAGE_SECTION_SUCCESS",
    _FAILURE: "SEE_ALL_ACTIONS_HOME_PAGE_SECTION_FAILURE"
  }
};

export const SEARCH_ACTIONS = {
  SEARCH_DATA: {
    _START: "SEARCH_ACTIONS_SEARCH_DATA_START",
    _SUCCESS: "SEARCH_ACTIONS_SEARCH_DATA_SUCCESS",
    _FAILURE: "SEARCH_ACTIONS_SEARCH_DATA_FAILURE",
    _RESET: "SEARCH_ACTIONS_SEARCH_DATA_RESET"
  }
};

export const EVENT_ACTIONS = {
  EVENT_LIST_DATA: {
    _START: "EVENT_ACTIONS_EVENT_LIST_DATA_START",
    _SUCCESS: "EVENT_ACTIONS_EVENT_LIST_DATA_SUCCESS",
    _FAILURE: "EVENT_ACTIONS_EVENT_LIST_DATA_FAILURE"
  },
  EVENT_DATA: {
    _START: "EVENT_ACTIONS_EVENT_DATA_START",
    _SUCCESS: "EVENT_ACTIONS_EVENT_DATA_SUCCESS",
    _FAILURE: "EVENT_ACTIONS_EVENT_DATA_FAILURE"
  }
};

export const COMPANY_PAGE_ACTIONS = {
  _RESET: "RESET_COMPANY_PAGE_DATA",
  SUB_MENU: {
    _START: "SUB_MENU_START",
    _SUCCESS: "SUB_MENU_SUCCESS",
    _FAILURE: "SUB_MENU_FAILURE"
  },
  SUB_MENU_VIDEO: {
    _START: "SUB_MENU_VIDEO_START",
    _SUCCESS: "SUB_MENU_VIDEO_SUCCESS",
    _FAILURE: "SUB_MENU_VIDEO_FAILURE"
  },
  SUB_MENU_SPONSORED_BY_VIDEO: {
    _START: "SUB_MENU_SPONSORED_BY_VIDEO_START",
    _SUCCESS: "SUB_MENU_SPONSORED_BY_VIDEO_SUCCESS",
    _FAILURE: "SUB_MENU_SPONSORED_BY_VIDEO_FAILURE"
  },
  PROMOTED_ID_LIST: {
    _START: "PROMOTED_ID_LIST_START",
    _SUCCESS: "PROMOTED_ID_LIST_SUCCESS",
    _FAILURE: "PROMOTED_ID_LIST_FAILURE"
  }
};

export const EVENT_PAGE_ACTIONS = {
  EVENT_DATA: {
    _SUCCESS: "EVENT_ACTIONS_EVENT_DATA_SUCCESS",
    _FAILURE: "EVENT_ACTIONS_EVENT_DATA_FAILURE"
  }
}

export const FOR_YOU_PAGE_ACTIONS = {
  _RESET: "RESET_FOR_YOU_PAGE_DATA",
  SUB_MENU_VIDEO: {
    _START: "SUB_MENU_VIDEO_START",
    _SUCCESS: "SUB_MENU_VIDEO_SUCCESS",
    _FAILURE: "SUB_MENU_VIDEO_FAILURE"
  },
  SUB_MENU_SPONSORED_BY_VIDEO: {
    _START: "SUB_MENU_SPONSORED_BY_VIDEO_START",
    _SUCCESS: "SUB_MENU_SPONSORED_BY_VIDEO_SUCCESS",
    _FAILURE: "SUB_MENU_SPONSORED_BY_VIDEO_FAILURE"
  }
};

export const EXPERT_PAGE_ACTIONS = {
  _RESET: "RESET_EXPERT_PAGE_DATA",
  SUB_MENU: {
    _START: "SUB_MENU_START",
    _SUCCESS: "SUB_MENU_SUCCESS",
    _FAILURE: "SUB_MENU_FAILURE"
  },
  SUB_MENU_VIDEO: {
    _START: "SUB_MENU_VIDEO_START",
    _SUCCESS: "SUB_MENU_VIDEO_SUCCESS",
    _FAILURE: "SUB_MENU_VIDEO_FAILURE"
  }
};

export const SERIES_PAGE_ACTIONS = {
  _RESET: "RESET_SERIES_PAGE_DATA",
  SERIES_DETAIL: {
    _START: "SERIES_DETAIL_START",
    _SUCCESS: "SERIES_DETAIL_SUCCESS",
    _FAILURE: "SERIES_DETAIL_FAILURE"
  },
  SERIES_VODS: {
    _START: "SERIES_VODS_START",
    _SUCCESS: "SERIES_VODS_SUCCESS",
    _FAILURE: "SERIES_VODS_FAILURE"
  }
};

export const LANGUAGE_ACTIONS = {
  CHANGE: "LANGUAGE_CHANGE"
}

export const REGISTRATION_STATUS = {
  _WAITING: "REGISTRATION_STATUS_WAITING",
  _LOADING: "REGISTRATION_STATUS_LOADING",
  _FAILURE: "REGISTRATION_STATUS_FAILURE",
  _SUCCESS: "REGISTRATION_STATUS_SUCCESS",
}